// Signed in but not yet decided (`status === 'pending'`): rendered by
// CaveArea directly inside PublicLayout's dark `cave-main`, the same way
// Landing is for the signed-out case — NOT inside `.chv-app`, since that
// wrapper only exists once a session is actually let aboard.
import { useRef } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { logout } from '../api.js';
import { Opener } from '../site/Opener.js';
import { useReveal } from '../site/motion.js';
import styles from './PendingApproval.module.css';

export function PendingApproval() {
  const scopeRef = useRef<HTMLDivElement | null>(null);
  useReveal(scopeRef);
  const queryClient = useQueryClient();

  const signOut = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      queryClient.setQueryData(['me'], null);
      queryClient.clear();
    },
  });

  return (
    <div ref={scopeRef}>
      <Opener lines={['Your request', 'is with the officers']} />
      <section className="wrap section">
        <div className="prose big narrow" data-reveal>
          <p>
            An officer will look at your request in Discord soon. Come back once you&apos;ve been let
            aboard.
          </p>
          <button
            type="button"
            className={`pill ${styles.signOut}`}
            disabled={signOut.isPending}
            onClick={() => signOut.mutate()}
          >
            Sign out
          </button>
        </div>
      </section>
    </div>
  );
}
